import { hasTradePlatformAccess } from './authAccess';
import { canAccessTradeWorkspace } from './brokerConnection';
import { DASHBOARD_ROUTES } from '../constants/dashboardRoutes';

/**
 * Primary app destinations for header / landing nav (tier-aware).
 */
export function getAppNavRoutes(user) {
  const hasAccess = Boolean(user?.token) && hasTradePlatformAccess(user);
  const showTrade = canAccessTradeWorkspace(user) !== false;

  return {
    showDashboard: hasAccess,
    dashboardPath: '/dashboard',
    blogPath: '/blog',
    tradePath: showTrade ? '/trade' : DASHBOARD_ROUTES.overview,
    /** Same destination as tradePath; "Dashboard" when Trade workspace is unavailable. */
    tradeLabel: showTrade ? 'Trade' : 'Portfolio',
    showTrade,
    homePath: '/home',
    featuresPath: '/features',
    settingsPath: hasAccess ? '/dashboard/settings' : '/settings',
  };
}
